import {reactive} from 'vue';
import {parseParams, XHR_STATUS_DEFAULT} from '@/utils/portuna';
import dateHelper from '@/utils/portuna/dateHelper';
import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';

// {year: {day: name}}
let holidays: Record<string, Record<string, string>> = reactive({});
let holidaysFetching: Record<string, boolean> = {};

@Component
export default class ADatePicker extends Vue
{
    @Prop({
        type: Boolean,
        default: false,
        required: false,
    }) showHolidays: boolean;

    @Prop({
        type: String,
        default: null,
        required: false,
    }) holidayState: Nullable<string>;

    @Prop({
        type: String,
        default: null,
        required: false,
    }) holidayPostcode: Nullable<string>;

    @Prop({
        type: Number,
        default: 0,
        required: false,
    }) holidayAddress: number;

    @Prop({
        type: Boolean,
        default: false,
        required: false,
    }) blockHolidays: boolean;

    selectedDate: string = '';

    selectedYear: number = 0;

    selectedMonth: number = 0;

    selectedDay: number = 0;

    selectedHour: number = 0;

    selectedMinute: number = 0;

    @Watch('holidayParamId')
    watchHolidayParamId(): void
    {
        if (this.useHolidays)
        {
            this.fetchHolidays();
        }
    }

    get useHolidays()
    {
        return this.showHolidays || this.blockHolidays;
    }

    get yearHolidays(): Record<string, string>
    {
        return holidays[this.holidayParamId] ?? {};
    }

    get holidayParamId()
    {
        return parseParams(this.holidayParams);
    }

    get holidayParams()
    {
        return {
            year: this.selectedYear,
            state: this.holidayState,
            postcode: this.holidayPostcode,
            address: this.holidayAddress,
        };
    }

    getHolidayInfo(date: Date)
    {
        const dateISO = dateHelper('Y-m-d', date) as string;
        const isHoliday = !!(this.useHolidays && this.yearHolidays[dateISO]);

        return {
            isHoliday,
            holidayTitle: isHoliday ? `<strong>Feiertag:</strong><br>` + this.yearHolidays[dateISO] : '',
            blocked: isHoliday && this.blockHolidays,
        };
    }

    fetchHolidays()
    {
        if (holidays[this.holidayParamId] || holidaysFetching[this.holidayParamId])
        {
            return;
        }

        holidaysFetching[this.holidayParamId] = true;

        this.axios.get('/application/ajax/fetch-holidays' + this.holidayParamId).then(response =>
        {
            if (response.data.status !== XHR_STATUS_DEFAULT)
            {
                throw response;
            }

            holidays[this.holidayParamId] = response.data.data.days;
        })
        .catch(console.error);
    }
};